  <template lang="pug">
.conversation-row(v-if="case_id", :class="{'row-selected': isRowSelected(index)}")
  b-form-row.align-items-center.flex-nowrap
    b-link(:to="changeCase()", @click="handleClick()").d-flex.link
      b-col(cols="auto")
        Avatar(size="xs", :src="User.profile_pic")
      b-col(cols="6").d-flex.flex-column.justify-content-center
        span {{ userName }}
        span.text-sm
          b-badge(pill :variant="getOutboundColor(outbound)") {{ getOutboundWord(outbound) }}
      b-col.d-flex.justify-content-center.align-items-center
        span.text-sm.mr-3.text {{ this.$moment(createdAt).format('DD/MM/YY') }}
        span(v-if="outbound")
          phone-outgoing-icon.icon-md
        span(v-else)
          phone-incoming-icon.icon-md
</template>

<script>
import Avatar from './Avatar.vue'
import CaseStatusBadge from './CaseStatusBadge.vue'

export default {
  data () {
    return {
      case_id: ''
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    Admin: {
      type: Object,
      default: function () {
        return {}
      }
    },
    User: {
      type: Object,
      default: function () {
        return {}
      }
    },
    answer_by: {
      type: Number,
      default: undefined
    },
    outbound: {
      type: Boolean,
      default: true
    },
    phone_number: {
      type: String,
      default: ''
    },
    user_id: {
      type: Number,
      default: undefined
    },
    createdAt: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: null
    },
    selectedIndex: {
      type: Number,
      default: null
    }
  },
  computed: {
    userName() {
      if (this.User && (this.User.first_name || this.User.last_name)) {
        return `${this.User.first_name || ''} ${this.User.last_name || ''}`
      } else {
        return this.User.external_id || 'Usuario'
      }
    }
  },
  methods: {
    putCaseId() {
      if (this.User && this.User.Cases && this.User.Cases.length > 0) {
        this.case_id = this.User.Cases[0].case_id
      }
    },
    changeCase() {
      return { name: 'Case', params: { case_id: this.case_id } }
    },
    isRowSelected(index) {
      return index === this.selectedIndex
    },
    handleClick() {
      this.$emit('click', { case_id: this.case_id, index: this.index })
    },
    getOutboundColor(status) {
      const color = {
        true: 'soft-success',
        false: 'soft-primary'
      }[status]

      return color
    },
    getOutboundWord(status) {
      const color = {
        true: 'Saliente',
        false: 'Entrante'
      }[status]

      return color
    },
    getOutboundIcon(status) {
      const color = {
        true: 'phone-outgoing',
        false: 'phone-incoming'
      }[status]

      return color
    }
  },
  mounted () {
    this.putCaseId()
  },
  components: { Avatar, CaseStatusBadge }
}
</script>

<style lang="scss" scoped>
  .link {
    text-decoration: none;
    color: black;
  }
  .text {
    font-weight: 900;
    font-size: 14px;
  }
  .conversation-row {
    width: 100%;
    padding: 0.5rem;
    transition: 0.5s;
    border-right: 2px solid transparent;

    &:not(:first-child) {
      border-top: 1px solid #edf2f9;
    }

    &[selected] {
      border-right: 2px solid #0e5ccf;
    }
  }

  .row-selected {
    background-color: rgba(14, 92, 207, 0.1);
  }

  .delete-underlined{
    text-decoration: none;
  }

  .delete-underlined:hover{
    color: #95aac9;
  }
</style>
